import React, { useState, useEffect } from 'react';
import { useForm, Controller } from "react-hook-form";
import Select from "react-select";
import Services from 'API/services'

const AreaFilter = ({ aSize = 6, bSize = 6, onPropertyChange }) => {

    const {
        register,
        watch,
        control,
        formState: { errors },
    } = useForm();

    const { zone, state, hub, city, selectProperty } = watch();

    const [zones, setZones] = useState([])
    const [states, setStates] = useState([])
    const [hubs, setHubs] = useState([])
    const [cities, setCities] = useState([])
    const [allProperty, setAllProperty] = useState([])
    const [selectedProperty, setSelectedProperty] = useState([]);

    const fetchZones = async () => {
        try {
            const res = await Services.property.allZoneService()
            if (res.data.status === true) {
                setZones(res.data.data)
            }
        }
        catch { }
    }

    useEffect(() => {
        fetchZones()
    }, [])

    const fetchStateByZone = async () => {
        try {
            const res = await Services.property.getStateByZone(zone)
            if (res.data.status === true) {
                setStates(res.data.data)
            }
        }
        catch { }
    }

    useEffect(() => {
        if (zone) {
            fetchStateByZone(zone)
        }
    }, [zone])

    const fetchHubByState = async () => {
        try {
            const res = await Services.property.getHubByState(state)
            if (res.data.status === true) {
                setHubs(res.data.data.Hubs)
            }
        }
        catch { }
    }

    useEffect(() => {
        if (state) {
            fetchHubByState(state)
        }
    }, [state])

    const fetchCityByHub = async () => {
        try {
            const res = await Services.property.getCityByHub(hub)
            if (res.data.status === true) {
                setCities(res.data.data)
            }
        }
        catch { }
    }

    useEffect(() => {
        if (state) {
            fetchCityByHub(hub)
        }
    }, [hub])

    const fetchProperties = async () => {
        let zoneName = zones?.find((item) => item?.id == zone)?.name
        try {
            const param = `?countryId=IN&zone=${zoneName}&stateId=${state}&hub=${hub}&cityId=${city}`
            const res = await Services.property.getPropertyByArea(param)
            if (res.data.status === true) {
                setAllProperty(res?.data?.data)
            }
        }
        catch { }
    }

    useEffect(() => {
        fetchProperties()
    }, [city])

    const handlePropertyChange = (value) => {
        setSelectedProperty(value);
        if (onPropertyChange) {
            onPropertyChange(value);
        }
    };

    return (
        <div className='row'>
            <div className={`col-lg-${aSize}`}>
                <div className="form-group">
                    <label className="text-black m-0 fs-7">Select Zone</label>
                    <select
                        className="form-select"
                        {...register("zone")}
                    >
                        <option value="">Select Zone</option>
                        {zones?.map((item) => (
                            <option key={item.id} value={item?.id}>
                                {item?.name}
                            </option>
                        ))}
                    </select>
                </div>
            </div>
            <div className={`col-lg-${aSize}`}>
                <div className="form-group">
                    <label className="text-black m-0 fs-7">Select State</label>
                    <select
                        className="form-select"
                        {...register("state")}
                    >
                        <option value="">Select State</option>
                        {states?.map((item) => (
                            <option key={item.id} value={item?.id}>
                                {item?.name}
                            </option>
                        ))}
                    </select>
                </div>
            </div>
            <div className={`col-lg-${aSize}`}>
                <div className="form-group">
                    <label className="text-black m-0 fs-7">Select Hub</label>
                    <select
                        className="form-select"
                        {...register("hub")}
                    >
                        <option value="">Select Hub</option>
                        {hubs?.map((item) => (
                            <option key={item.id} value={item?.id}>
                                {item?.hubname}
                            </option>
                        ))}
                    </select>
                </div>
            </div>
            <div className={`col-lg-${aSize}`}>
                <div className="form-group">
                    <label className="text-black m-0 fs-7">Select City</label>
                    <select
                        className="form-select"
                        {...register("city")}
                    >
                        <option value="">Select City</option>
                        {cities?.map((item) => (
                            <option key={item.id} value={item?.id}>
                                {item?.name}
                            </option>
                        ))}
                    </select>
                </div>
            </div>
            <div className={`col-lg-${bSize}`}>
                <div className="form-group">
                    <label className="text-black m-0 fs-7">Select Property</label>
                    <Select
                        options={allProperty}
                        placeholder="Select a Property"
                        isSearchable
                        getOptionLabel={(e) => `${e.propertyCode} - ${e.name}`}
                        getOptionValue={(e) => e.id}
                        value={selectedProperty}
                        onChange={handlePropertyChange}
                        isMulti
                    />
                </div>
            </div>
        </div>
    )
}

export default AreaFilter